import React from "react";
import { Link } from "react-router-dom";
import { Image, ImageProps } from "semantic-ui-react";

export const Logo = (props: ImageProps) => (
  <Image src="https://dmra-pages-html.s3.us-west-2.amazonaws.com/logo.png" {...props} />
);
